import React, { useContext } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { getCoverImage } from "../../components/Firebase/storage";
import { SCENARIO_EDITOR, ORG_SETTINGS, ADMIN, ORG_VOICES } from "../../constants/routes";
import { isString } from "lodash";
import { AuthUserContext } from "../../components/Session";
import { DataStoreContext } from "../../components/DataStore/DataStoreContext";
import { checkAdmin, checkSuperAdmin } from "../../helpFunctions/auth";
import { FrTabLink, FrTabs } from "../../components/DesignSystem/style";

const PageTitleWrapper = styled.div`
  width: 100%;
  padding: ${props => (props.padding ? props.padding : "20px 0 20px 0")};
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;

  h1 {
    text-align: left;
    color: var(--grey);
    line-height: 39px;
    padding: 0;
    margin: 0;
  }

  h4 {
    text-align: left;
    color: var(--grey-2);
    line-height: 20px;
    span {
      color: var(--key-color-2);
    }
  }

  @media (max-width: 768px) {
    padding-top: 0px;
  }
`;

const DetailedTitleHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const DetailedTitleText = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const OrganizationLogo = styled.img`
  flex: 0 1 auto;
  width: min(320px, 38vw);
  max-height: 86px;
  object-fit: contain;
  object-position: right center;
  margin-left: auto;

  @media (max-width: 480px) {
    width: clamp(56px, 24vw, 110px);
    max-height: 56px;
  }
`;

export const PageTitle = ({ padding, title, secondTitle }) => {
  return (
    <PageTitleWrapper padding={padding}>
      <h1>{title}</h1>
      {secondTitle && <h4>{secondTitle}</h4>}
    </PageTitleWrapper>
  );
};

export const DetailedPageTitle = ({ title, padding, organization, userType }) => {
  const coverImage = organization?.id && getCoverImage(organization.coverImage, "320px");

  return (
    <PageTitleWrapper padding={padding}>
      <DetailedTitleHeader>
        <DetailedTitleText>
          <h1>{title}</h1>
          <h4>
            Organization:
            <span>{` ${organization?.displayName || organization?.id || (isString(organization) ? organization : "None")}`}</span>
          </h4>
          <h4>
            User Type:
            <span>{` ${userType || "None"}`}</span>
          </h4>
        </DetailedTitleText>
        {coverImage && <OrganizationLogo src={coverImage} alt="" />}
      </DetailedTitleHeader>
    </PageTitleWrapper>
  );
};

const AdminTabsWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--grey-4);
  margin-bottom: 20px;
`;

const AdminNav = () => {
  const { authUser } = useContext(AuthUserContext);
  const { state } = useContext(DataStoreContext);
  const location = useLocation();
  const activeLink = location.pathname || ADMIN;
  const isAdmin = checkAdmin(authUser?.claims, state.selectedOrg);
  const isSuperAdmin = checkSuperAdmin(authUser?.claims);

  return (
    <>
      {isAdmin && (
        <AdminTabsWrapper>
          <FrTabs>
            <li>
              <FrTabLink to={ADMIN} $selected={activeLink === ADMIN}>
                Overview
              </FrTabLink>
            </li>
            <li>
              <FrTabLink to={SCENARIO_EDITOR} $selected={activeLink.includes(SCENARIO_EDITOR)}>
                Scenario Editor
              </FrTabLink>
            </li>
            <li>
              <FrTabLink to={ORG_SETTINGS} $selected={activeLink.includes(ORG_SETTINGS)}>
                Organization Settings
              </FrTabLink>
            </li>
            {isSuperAdmin && (
              <li>
                <FrTabLink to={ORG_VOICES} $selected={activeLink.includes(ORG_VOICES)}>
                  Voices
                </FrTabLink>
              </li>
            )}
          </FrTabs>
        </AdminTabsWrapper>
      )}
    </>
  );
};

export const AdminNavigation = AdminNav;
